// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AttendClassJoinClass
{
    background-color: #edffff;
    width: 100%;
    height: auto;
    text-align: center;
    height: 80vh;
}
.AttendClassRate
{
    width: 30%;
    height: auto;
    border-radius: 5vh;
    background-color: #bbf0fa;
    padding:3%;
    margin-left: 35%;
}
.AttendClassComment
{
    width: 50%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    resize: vertical;
}
.AttendClassSendRating
{
    background-color: #03b4c6;
    color: white;
    padding: 12px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    width: 50%;
    margin-top: 1%;
}
.AttendClassBtn
{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #edffff;
    margin: 2%;

}
.AttendClassAttendInput
{
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    resize: vertical;
}
.AttendClassjoinBtn
{
    background-color: #bbf0fa;
    color: #03b4c6;
    padding: 12px 20px;
    border: none;
    border-radius: 2vh;
    font-size: 3vh;
    cursor: pointer;
    float: right;
    width: 25%;
    box-shadow: 0 3px 5px 0 rgba(100, 96, 96, 0.3); /* This creates a shadow effect */
    
}
.AttendClassjoinBtn:hover{
    background-color:#03b4c6 ;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/Actions/AttendClass.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;AACA;;IAEI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB;AACA;;IAEI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,cAAc;AAClB;AACA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;;AAEd;AACA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;;IAEI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,UAAU;IACV,8CAA8C,EAAE,iCAAiC;;AAErF;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":[".AttendClassJoinClass\n{\n    background-color: #edffff;\n    width: 100%;\n    height: auto;\n    text-align: center;\n    height: 80vh;\n}\n.AttendClassRate\n{\n    width: 30%;\n    height: auto;\n    border-radius: 5vh;\n    background-color: #bbf0fa;\n    padding:3%;\n    margin-left: 35%;\n}\n.AttendClassComment\n{\n    width: 50%;\n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n    resize: vertical;\n}\n.AttendClassSendRating\n{\n    background-color: #03b4c6;\n    color: white;\n    padding: 12px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    width: 50%;\n    margin-top: 1%;\n}\n.AttendClassBtn\n{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #edffff;\n    margin: 2%;\n\n}\n.AttendClassAttendInput\n{\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n    resize: vertical;\n}\n.AttendClassjoinBtn\n{\n    background-color: #bbf0fa;\n    color: #03b4c6;\n    padding: 12px 20px;\n    border: none;\n    border-radius: 2vh;\n    font-size: 3vh;\n    cursor: pointer;\n    float: right;\n    width: 25%;\n    box-shadow: 0 3px 5px 0 rgba(100, 96, 96, 0.3); /* This creates a shadow effect */\n    \n}\n.AttendClassjoinBtn:hover{\n    background-color:#03b4c6 ;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
